import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings

class Christmas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newchristmaspage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "newChristmas",
    }).then((entries) => {
      this.setState({ newchristmaspage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(newchristmasDescription) {
    return {
      __html: marked(newchristmasDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <>
      <div className="container-fluid">
        {this.state.newchristmaspage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.newchristmaspage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1 className="text-uppercase">{item.fields.newChristmasTitle}</h1>
                    {/* <h2 className="lead">{item.fields.newchristmasShortDetails}</h2> */}
                  </div>

                  <div className="pt-2">
                    <div className="row">
                      {/* <div className="col-lg-4">
                        <img
                          className="img-fluid"
                          src={item.fields.newchristmasImg.fields.file.url}
                          alt="icon"
                        />
                        
                      </div> */}
                      <div className="col-lg-8">
                        {/* <p>{item.fields.aboutDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.newchristmasDescription
                        )}></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="pt-4">
      {/* <FallThingsGallery/> */}
      </div>
      </>
    );
  }
}

export default Christmas;
